/* import __COLOCATED_TEMPLATE__ from './pagedlist-controls.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
let PagedlistControlsComponent = (_class = class PagedlistControlsComponent extends Component {
  get offset() {
    return this.args.offset ? parseInt(this.args.offset, 10) : 0;
  }
  get limit() {
    return this.args.limit ? parseInt(this.args.limit, 10) : 0;
  }
  get total() {
    return this.args.total ? parseInt(this.args.total, 10) : 0;
  }
  get firstPage() {
    return this.offset <= 0;
  }
  get numPages() {
    if (this.limit) {
      return Math.ceil(this.total / this.limit);
    }
    return 1;
  }
  get start() {
    return this.offset + 1;
  }
  get end() {
    const total = this.total;
    let end = this.offset + this.limit;
    if (end > total) {
      end = total;
    }
    return end;
  }
  get offsetOptions() {
    const total = this.args.limitless ? 1000 : this.total;
    const available = [10, 25, 50, 100, 200, 400, 1000];
    const options = available.filter(option => {
      return option < total;
    });
    options.push(available[options.length]);
    return options;
  }
  get lastPage() {
    if (this.args.limitless) {
      // return false;
      return this.limit >= this.total;
    }
    return this.offset + this.limit >= this.total;
  }
  goForward() {
    const offset = this.offset;
    const limit = this.limit;
    this.args.setOffset(offset + limit);
  }
  goToFirst() {
    this.args.setOffset(0);
  }
  goToLast() {
    this.args.setOffset(this.limit * (this.numPages - 1));
  }
  goBack() {
    const offset = this.offset;
    const limit = this.limit;
    this.args.setOffset(offset - limit);
  }
  setOffset(offset) {
    const limit = this.limit;
    const total = this.total;
    const largestOffset = total - limit;
    if (offset < 0) {
      offset = 0;
    }
    if (offset > largestOffset) {
      offset = largestOffset;
    }
    this.args.setOffset(offset);
  }
  setLimit(limit) {
    this.args.setLimit(parseInt(limit, 10));
    this.args.setOffset(0);
  }
}, _applyDecoratedDescriptor(_class.prototype, "goForward", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goForward"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToFirst", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToFirst"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToLast", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToLast"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goBack", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goBack"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOffset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setOffset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setLimit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setLimit"), _class.prototype), _class);
export { PagedlistControlsComponent as default };